import { useEffect, useRef } from "react";

export function BookingWidget() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const widgetDiv = document.createElement("div");
    widgetDiv.className = "booking-widget";
    widgetDiv.setAttribute("data-widget", "apa-automotive-apa-automotive-bdf41f85");
    widgetDiv.setAttribute("data-key", "wk_live_t9KMSjST761eQo32gil-y746hTnEoMo1eSdTo5oNuEU");
    el.appendChild(widgetDiv);

    const script = document.createElement("script");
    script.src = "https://api.bookingapi.ca/widget/v1/embed.js";
    script.defer = true;
    el.appendChild(script);

    return () => { el.innerHTML = ""; };
  }, []);

  return <div ref={containerRef} />;
}
